import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]" data-testid="auth-loading">
      <Loader2 className="animate-spin text-[#0A0A0A]" size={32} />
    </div>
  );
}

export function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!["super_admin", "employee"].includes(user.role)) {
    return <Navigate to={user.role === "volunteer" ? "/volunteer" : "/account"} replace />;
  }
  return children;
}

export function VolunteerRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login?portal=volunteer" replace />;
  if (user.role !== "volunteer") {
    return <Navigate to={["super_admin", "employee"].includes(user.role) ? "/admin" : "/account"} replace />;
  }
  return children;
}

export function AccountRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "volunteer") return <Navigate to="/volunteer" replace />;
  return children;
}
